import React, { useState, useEffect, useRef } from "react";
import { regPass } from "../../components/logic";
import Btn from "./Btn";
import AgreementDialog from "../sign/AgreementDialog";
import InputBox from "./InputBox";

const PassInput = ({ onSaveEach, onSaveAgreement }) => {
    const [pwd, setPwd] = useState({ pass: "", again: "" });
  const [active1, setActive1] = useState("ready");
  const [active2, setActive2] = useState("ready");
  const [errorMsg, setErrorMsg] = useState({
    msg1: "At least 6 characters with letters and numbers",
    msg2: "",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const passRef = useRef(null);
  const againRef = useRef(null);

  const onChangeInput1 = (e) => {
    setPwd({ ...pwd, pass: e.target.value });
    if (!regPass(e.target.value)) {
      setErrorMsg({
        msg1: "At least 6 characters with letters and numbers",
        msg2: "",
      });
      setActive1("ready");
      setActive2("ready");
    } else {
      setErrorMsg({ msg1: "", msg2: "" });
      setActive1("on");
    }
  };

  const onChangeInput2 = (e) => {
    setPwd({ ...pwd, again: e.target.value });
    if (pwd.pass !== e.target.value) {
      setErrorMsg({
        ...errorMsg,
        msg2: "Re-enter your password to confirm",
      });
      setActive2("ready");
    } else {
      if (active1 === "on") {
        setErrorMsg({ ...errorMsg, msg2: "Passwords match" });
        setActive2("on");
      } else setActive2("ready");
    }
  };

  const onDeleteValue = (type) => {
    if (type === "pass") {
      setPwd({ pass: "", again: "" });
      setErrorMsg({ ...errorMsg, msg1: "" });
      passRef.current?.focus();
      setActive1("ready");
      setActive2("ready");
    } else {
      setActive2("ready");
      setPwd({ ...pwd, again: "" });
      setErrorMsg({ ...errorMsg, msg2: "" });
      againRef.current?.focus();
    }
  };

  const onSavePass = (e) => {
    e.preventDefault();
    onSaveEach("pass", pwd.pass);
    setOpenDialog(true);
    setPwd({ pass: "", again: "" });
  };

  useEffect(() => {
    let focused = true;
    if (focused) passRef.current?.focus();
    return () => (focused = false);
  }, [passRef]);

  // Check if we're returning from viewing a policy
  useEffect(() => {
    const shouldReturnToDialog = sessionStorage.getItem('returnToAgreementDialog');
    if (shouldReturnToDialog === 'true') {
      setOpenDialog(true);
      sessionStorage.removeItem('returnToAgreementDialog');
    }
  }, []);

  return (
    <>
      {/* Agreement dialog intentionally prevents closing */}
      <div
        className={
          openDialog
            ? "fixed left-0 top-0 z-10 h-full w-full bg-black opacity-70"
            : "hidden"
        }
      ></div>
      <form
        onSubmit={
          active1 === "on" && active2 === "on"
            ? onSavePass
            : (e) => e.preventDefault()
        }
        className={"space-y-6 " + (openDialog ? "hidden" : "relative")}
      >
        <InputBox
          option="pass"
          refName={passRef}
          id={"pass"}
          nameTitle={"pass"}
          placeholder={"Password"}
          onChangeAction={(e) => onChangeInput1(e)}
          value={pwd.pass || ""}
          active={active1}
          onClickAction={() => onDeleteValue("pass")}
          errorMsg={errorMsg.msg1}
        />
        <InputBox
          option="pass"
          refName={againRef}
          id={"again"}
          nameTitle={"again"}
          placeholder={"Confirm Password"}
          onChangeAction={(e) => onChangeInput2(e)}
          value={pwd.again || ""}
          active={active2}
          onClickAction={() => onDeleteValue("again")}
          errorMsg={errorMsg.msg2}
        />
        <Btn
          option={"bottom"}
          title={"Save Password"}
          bgColor={"bg-main"}
          textColor={"text-white"}
          borderColor={"border border-main"}
          active={active1 === "on" && active2 === "on" ? "on" : "ready"}
        />
      </form>
      <AgreementDialog
        openDialog={openDialog}
        onSaveAgreement={onSaveAgreement}
      />
    </>
  );
};

export default PassInput;
